module.exports = __webpack_public_path__ + "eb5c8c08d7563671b75abdd4782079cb.png";